module.exports = __webpack_public_path__ + "static/media/vliegtuig_in_de_lucht.7d214999.png";